import { DictionaryPhrases } from '@sitecore-jss/sitecore-jss-react';
import useDictionary from 'lib/sitecore/use-dictionary';
import { RefinementList, RefinementListProps } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';

import { useSearchDictionary } from '../util';

let dict: DictionaryPhrases;

// Had to move this out of the component due to an infinite loop bug similar to this one: https://github.com/algolia/instantsearch.js/issues/1990
const transformItems: RefinementListProps['transformItems'] = (items) => {
  if (dict) {
    return items.map((item) => ({
      ...item,
      label: dict[item.value] as string,
    }));
  }

  return items;
};

const FileTypeFacet = () => {
  const searchDict = useSearchDictionary();
  dict = useDictionary();

  return (
    <div className={classnames('mb-4')}>
      <div className={classnames('text-blue-navy', 'heading-sm', 'mb-6')}>
        {searchDict.fileType}
      </div>
      <RefinementList
        transformItems={transformItems}
        attribute="fileTypeId"
        sortBy={['name:asc']}
      />
    </div>
  );
};

export default FileTypeFacet;
